import { useQueryClient } from 'react-query';
import { BookingRange } from '../../types';
import {
    CustomerBookingsStaleTimeInMilliseconds,
    customerBookingsQueryKey,
    fetchCustomerBookings
} from './customerBookingsQuery';

export function usePrefetchCustomerBookings() {
    const queryClient = useQueryClient();

    return function prefetchCustomerBookings(range: BookingRange) {
        queryClient.prefetchQuery(
            customerBookingsQueryKey(range),
            () => fetchCustomerBookings(range),
            { staleTime: CustomerBookingsStaleTimeInMilliseconds }
        );
    };
}
